module.exports = __webpack_public_path__ + "static/media/blog_grid_4.06bb271b.jpg";